var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { FileUpload } from '../../shared/app/classes/file-upload';
import { HttpClientModule } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Validation } from '../../shared/app/services/validation';
import { PayeeAttachment, PayeeAttachmentDetail, SubmissionTag, SubmissionSubtagMapping, PayeeServiceDPE } from '../../shared/sdk/models';
import { PayeeApi, StorageApi, PayeeSubmissionApi, PayeeServiceApi, PayeeCardsEcommerceApi } from '../../shared/sdk/services';
import { GlobalEventsManager } from '../../events-manager.component';
import { SubmissionDetailService } from '../../shared/app/services/';
import { CONSTANT } from '../../shared/app/constants';
var ɵ0 = window;
var JompayDocumentsUploadComponent = /** @class */ (function (_super) {
    __extends(JompayDocumentsUploadComponent, _super);
    function JompayDocumentsUploadComponent(payeeApi, payeeCardsEcommerceApi, payeeServiceApi, payeeSubmissionApi, router, storageApi, eventManager, validation, submissionDetailService, sanitizer, http, document) {
        var _this = _super.call(this, payeeApi, storageApi, eventManager) || this;
        _this.payeeApi = payeeApi;
        _this.payeeCardsEcommerceApi = payeeCardsEcommerceApi;
        _this.payeeServiceApi = payeeServiceApi;
        _this.payeeSubmissionApi = payeeSubmissionApi;
        _this.router = router;
        _this.storageApi = storageApi;
        _this.eventManager = eventManager;
        _this.validation = validation;
        _this.submissionDetailService = submissionDetailService;
        _this.sanitizer = sanitizer;
        _this.http = http;
        _this.document = document;
        _this.TAG = 'JompayDocumentsUploadComponent';
        _this.CONSTANT = CONSTANT;
        _this.new = false;
        _this.valid = true;
        _this.usignedJompayLoSrc = null;
        _this.loFilename = null;
        _this.usignedJompaySaSrc = null;
        _this.saFilename = null;
        _this.usignedJompayAccAuthSrc = null;
        _this.accAuthFilename = null;
        return _this;
    }
    // Initialisation
    JompayDocumentsUploadComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.scrollToTop();
                this.randomFileName = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + '.pdf';
                if (window.screen.width < 1200) { // 768px portrait
                    this.isMobile = true;
                }
                this.getAttachments().subscribe(function (res) {
                    _this.eventsManager.loaded(true);
                    console.log(' === Attachments Upload: ');
                    console.log("-------------carmen---------->", res);
                    _this.attachmentsObj = res.attachments;
                    if (res.attachments.length > 0) {
                        for (var _i = 0, _a = res.attachments; _i < _a.length; _i++) {
                            var attach = _a[_i];
                            switch (attach.type) {
                                case 'signed_jompay_lo':
                                    _this.usignedJompayLoSrc = (!attach.detail || attach.detail.acceptance) ? attach.file_name : '';
                                    break;
                                case 'signed_jompay_sa':
                                    _this.usignedJompaySaSrc = (!attach.detail || attach.detail.acceptance) ? attach.file_name : '';
                                    break;
                                case 'signed_jompay_accauth':
                                    _this.usignedJompayAccAuthSrc = (!attach.detail || attach.detail.acceptance) ? attach.file_name : '';
                                    break;
                                default: break;
                            }
                        }
                    }
                }, function (err) {
                    _this.eventsManager.loaded(true);
                    console.log(err);
                });
                // this.getFileDetails('signed_jompay_lo').subscribe(
                //   fileRes => {
                //     if (fileRes.length > 0) {
                //       console.log(this.TAG + ' getFileDetails("signed_jompay_lo")');
                //       console.log(fileRes[0]);
                //       this.loFilename = fileRes[0].file_name;
                //     }
                //   }
                // );
                console.log('Jompay Upload component');
                console.log(this.submission);
                return [2 /*return*/];
            });
        });
    };
    JompayDocumentsUploadComponent.prototype.getAttachments = function () {
        var filter = {
            include: [{
                    relation: 'attachments',
                    scope: {
                        where: {
                            'or': [
                                {
                                    'type': 'jompay_offer_letter',
                                    'isDeleted': false
                                },
                                {
                                    'type': 'signed_jompay_lo',
                                    'isDeleted': false
                                },
                                {
                                    'type': 'signed_jompay_sa',
                                    'isDeleted': false
                                },
                                {
                                    'type': 'signed_jompay_accauth',
                                    'isDeleted': false
                                },
                            ]
                        },
                        include: 'detail',
                        order: 'created_at ASC'
                    }
                },
                {
                    relation: 'submission_subtags',
                    scope: {
                        where: {
                            'deleted_at': null
                        }
                    }
                },
                "submission_tags",
                "payee"
            ]
        };
        return this.payeeSubmissionApi.findById(this.submission.submission_id, filter);
    };
    JompayDocumentsUploadComponent.prototype.addEventListeners = function () { };
    JompayDocumentsUploadComponent.prototype.submit = function (submit) {
        var _this = this;
        this.valid = this.validate();
        if (this.valid) {
            console.log(this.TAG + ':submit');
            var fdata = {
                'tag_id': this.CONSTANT.STATUS.JOMPAY.CUSTOMER_UPLOADED_DOCUMENTS,
                'payee_id': this.submission.payee_id,
                'current': true
            };
            this.payeeSubmissionApi.createSubmission_tags(this.submission.submission_id, fdata).subscribe(function (res) {
                if (res) {
                    _this.eventsManager.showPopUp('Jompay documents has been submitted.');
                    _this.router.navigate(['/dashboard']);
                    console.log('res', res);
                }
            });
            // let promises = [];
            // promises.push(this.saveTechDetails());
            // Promise.all(promises)
            //   .then(
            //     res => {
            //       this.eventsManager.showPopUp('Jompay documents has been submitted.');
            //       this.router.navigate(['/dashboard']);
            //     },
            //     err => {
            //       this.eventsManager.showPopUp('Unable to submit. Please try again later');
            //     }
            //   )
        }
        else {
            this.eventsManager.showPopUp('Please choose file before submit.');
        }
    };
    JompayDocumentsUploadComponent.prototype.saveTechDetails = function () {
        var that = this;
        var details = {
            uat_test_pop_up_sc: this.usignedJompayLoSrc,
            uat_test_rpn_sc: this.usignedJompaySaSrc,
            uat_test_rpn_sc1: this.usignedJompayAccAuthSrc,
        };
        // console.log(this.payeeId);
        if (this.usignedJompayLoSrc && this.usignedJompaySaSrc && this.usignedJompayAccAuthSrc) {
        }
    };
    JompayDocumentsUploadComponent.prototype.addDoc = function (name, event, zip, submissionId, payeeId, submissionType) {
        _super.prototype.addDoc.call(this, name, event, zip, submissionId, payeeId, submissionType);
        for (var i = 0; i < this.attachmentsObj.length; i++) {
            if (this.attachmentsObj[i].type === name) {
                var fdata = {
                    "acceptance": true
                };
                this.payeeSubmissionApi.payeeAttachmentStatus(this.attachmentsObj[i].id, fdata).subscribe(function (res) {
                    if (res) {
                        console.log('attachment status updated..', res);
                    }
                });
            }
        }
    };
    JompayDocumentsUploadComponent.prototype.deleteDoc = function (name) {
        _super.prototype.deleteDoc.call(this, name);
    };
    JompayDocumentsUploadComponent.prototype.updateDocStatus = function (name, fileName) {
        switch (name) {
            case 'signed_jompay_lo':
                this.usignedJompayLoSrc = fileName;
                break;
            case 'signed_jompay_sa':
                this.usignedJompaySaSrc = fileName;
                break;
            case 'signed_jompay_accauth':
                this.usignedJompayAccAuthSrc = fileName;
                break;
        }
    };
    ;
    JompayDocumentsUploadComponent.prototype.validateDocs = function () {
        this.docsValid = (this.usignedJompayLoSrc && this.usignedJompaySaSrc && this.usignedJompayAccAuthSrc);
        return this.docsValid;
    };
    ;
    JompayDocumentsUploadComponent.prototype.validate = function () {
        this.valid = this.validateDocs();
        return this.valid;
    };
    // Scrolling
    JompayDocumentsUploadComponent.prototype.scrollToTop = function () {
        window.scroll(0, 0);
        document.body.getElementsByClassName('scroll_cards_uat_live')[0].scrollTop = 0;
    };
    return JompayDocumentsUploadComponent;
}(FileUpload));
export { JompayDocumentsUploadComponent };
export { ɵ0 };
